<template>
  <div>
    <v-overlay v-if="loadingContent" class="text-center">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
      <p>Cargando Reserva</p>
    </v-overlay>

    <v-row>
      <v-col md="12" cols="12" class="ma-0 pa-0" v-show="!onlyEditPlayer">
        <v-card>
          <v-card-text>
            <v-row>
              <v-col md="4">
                <h3 class="mt-2 mb-n8">
                  {{ input_date.format("dddd DD [de] MMMM [de] YYYY") }} -
                  {{ selectedTime }} - {{ selectedTimeEnd }}
                  <v-btn
                    elevation="0"
                    color="primary"
                    small
                    @click="editingTimeDate = true"
                    v-show="!editingTimeDate"
                    ><v-icon>mdi-pencil</v-icon></v-btn
                  >
                </h3>
              </v-col>
              <v-col md="3">
                <div class="mx-2 mb-n8">
                  <v-autocomplete
                    outlined
                    dense
                    label="Modalidad"
                    :items="tiposJuego"
                    item-value="id"
                    item-text="nombre"
                    @input="changeModalidad"
                    v-model="modalidad"
                  >
                  </v-autocomplete>
                </div>
              </v-col>
              <v-col md="5">
                <v-row>
                  <v-col md="6" cols="12" style="display: flex">
                    <v-btn
                      v-if="false"
                      @click="
                        playersNumber > 1 ? playersNumber-- : '';
                        changePlayersNumber();
                      "
                    >
                      <v-icon color="red"> mdi-minus </v-icon>
                    </v-btn>
                    <v-text-field
                      disabled
                      class=""
                      outlined
                      dense
                      @keyup="changePlayersNumber()"
                      v-model="playersNumber"
                      label="Indica el numero de jugadores"
                    >
                    </v-text-field>
                    <v-btn
                      @click="
                        playersNumber++;
                        changePlayersNumber();
                      "
                    >
                      <v-icon color="green"> mdi-plus </v-icon>
                    </v-btn>
                  </v-col>
                  <v-col md="6" cols="12">
                    <v-text-field
                      class=""
                      outlined
                      dense
                      v-model="Invitados"
                      label="Personas Extra"
                    ></v-text-field>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col md="12" cols="12">
        <h4 v-if="editData.FechaCreacion" class="my-0">
          Folio: {{ Folio }} || Creado:
          {{ formatDate(editData.FechaCreacion) }} || Creado por:
          {{
            this.editData.Creador ? getInfoCajero(this.editData.Creador.Id) : ""
          }}
          ||
          <v-btn
            color="primary"
            small
            class="mx-1"
            @click="
              confirmationMail = editData.Cliente.Correo;
              sendConfirmModal = true;
            "
            dark
          >
            Enviar Confirmación
          </v-btn>
        </h4>
        <v-tabs
          next-icon="mdi-arrow-right-bold-box-outline"
          prev-icon="mdi-arrow-left-bold-box-outline"
          show-arrows
          v-model="extraTabs"
        >
          <v-tabs-slider></v-tabs-slider>
          <v-tab> Jugadores </v-tab>
          <v-tab v-if="!onlyEditPlayer"> Notas </v-tab>
          <v-tab v-if="!onlyEditPlayer"> </v-tab>
          <v-tab v-if="!onlyEditPlayer"> Transportación </v-tab>
          <v-tab v-if="!onlyEditPlayer"> Extra Riders </v-tab>
        </v-tabs>
        <v-tabs-items v-model="extraTabs">
          <v-tab-item :eager="true" class="pa-2">
            <v-tabs
              v-model="plyTabs"
              fixed-tabs
              dense
              background-color="indigo"
              dark
            >
              <v-tab> Nombres y Tarifas </v-tab>
              <v-tab> Extras </v-tab>
            </v-tabs>
            <v-tabs-items v-model="plyTabs">
              <v-tab-item :eager="true" class="pa-2">
                <v-form ref="playersForm">
                  <v-simple-table>
                    <thead>
                      <tr>
                        <th width="30%">Jugador</th>
                        <th width="20%">Tarifario</th>
                        <th width="20%">Tarifas</th>
                        <th width="10%">Precio</th>
                        <th width="10%">Opciones</th>
                      </tr>
                    </thead>
                    <tbody>
                      <template v-for="(player, index) in players">
                        <tr v-if="showPlayer(player, index)" :key="index">
                          <td class="pa-2">
                            <v-combobox
                              :label="'Jugador'"
                              class="mb-n6"
                              outlined
                              :search-input.sync="player.name"
                              dense
                              v-model="player.dataClient"
                              :items="comp_clients"
                              item-value="Id"
                              item-disabled="blqd"
                              @input="interceptorClient(player, index)"
                            >
                              <template v-slot:item="data">
                                <v-list-item-content
                                  v-bind:class="{
                                    accesoDenegado: data.item.blqd,
                                  }"
                                >
                                  {{ data.item.text }}<br />
                                  <b v-if="data.item.esMiembro"
                                    ><v-icon small color="yellow">
                                      mdi-star
                                    </v-icon>
                                    Miembro</b
                                  >
                                  <b v-if="data.item.blqd"
                                    ><v-icon small color="red">
                                      mdi-cancel
                                    </v-icon>
                                    Acceso denegado</b
                                  >
                                  <b v-if="data.item.blqd" class="mx-2 mb-2">{{
                                    data.item.nots
                                  }}</b>
                                  <v-chip color="primary" v-if="data.item.tipo">
                                    {{ data.item.tipo ? data.item.tipo : "" }}
                                  </v-chip>
                                </v-list-item-content>
                              </template>
                              <v-btn
                                small
                                @click="
                                  historyclient = player.dataClient;
                                  indexHistory++;
                                  showHistory = true;
                                "
                                elevation="0"
                                slot="append-outer"
                                outlined
                                dark
                                :color="$pgsHelper.uiConfig().mainColor"
                              >
                                <v-icon>mdi-account-clock</v-icon>
                              </v-btn>
                              <v-btn
                                small
                                elevation="0"
                                slot="append-outer"
                                @click="
                                  indexItem = index;
                                  idx.formClient++;
                                  showModalCliente = true;
                                "
                                dark
                                :color="$pgsHelper.uiConfig().mainColor"
                              >
                                <v-icon>mdi-account-plus</v-icon>
                              </v-btn>
                            </v-combobox>
                          </td>
                          <td class="pa-2">
                            <v-autocomplete
                              v-if="!player.useRondaCupon"
                              class="mb-n6"
                              :items="tarifaCombo"
                              outlined
                              dense
                              v-model="player.tarifario"
                              @input="getTarifasByTarifario(index)"
                              label="Seleccione un tarifario"
                            >
                            </v-autocomplete>
                          </td>
                          <td class="pa-2">
                            <h4 v-if="player.useRondaCupon">Ronda Prepagada</h4>
                            <v-autocomplete
                              v-if="!player.useRondaCupon"
                              class="mb-n6"
                              :items="player.listadoTarifas"
                              outlined
                              dense
                              v-model="player.tarifa"
                              @input="getTarifasByPlayer(index)"
                              :rules="Rules.Tarifa"
                              label="Seleccione una Tarifa"
                            >
                              <template v-slot:item="data">
                                <v-list-item-content>
                                  <v-list-item-title>
                                    {{ data.item.tarifarioName }}
                                    {{ data.item.text }}</v-list-item-title
                                  >
                                  <v-list-item-subtitle
                                    >{{ data.item.nombreHorario }} ${{
                                      data.item.Precio
                                    }}</v-list-item-subtitle
                                  >
                                  <v-list-item-subtitle
                                    >{{ data.item.temporadaName }} :
                                    {{
                                      $pgsHelper
                                        .getDate(data.item.Inicio)
                                        .format("DD/MM/YYYY")
                                    }}
                                    -
                                    {{
                                      $pgsHelper
                                        .getDate(data.item.Final)
                                        .format("DD/MM/YYYY")
                                    }}</v-list-item-subtitle
                                  >
                                </v-list-item-content>
                              </template>
                            </v-autocomplete>
                          </td>
                          <td class="pa-2">
                            <v-chip
                              color="red"
                              dark
                              small
                              v-if="player.tarifa == ''"
                            >
                              Sin Precio
                            </v-chip>
                            <v-text-field
                              class="mb-n6"
                              v-if="player.TarifaSelected"
                              outlined
                              dense
                              @keypress="
                                $pgsHelper.onlyNumber($event, player.Precio)
                              "
                              v-model="player.Precio"
                              label="Precio"
                            >
                              <v-chip
                                slot="append-outer"
                                color="green"
                                dark
                                small
                                v-if="player.TarifaSelected"
                              >
                                {{ player.TarifaSelected.Moneda }}
                              </v-chip>
                            </v-text-field>

                            <v-chip
                              color="red"
                              dark
                              small
                              v-if="
                                player.TarifaSelected == '' &&
                                player.tarifa != ''
                              "
                            >
                              Tarifa invalida
                            </v-chip>
                          </td>
                          <td style="white-space: nowrap">
                            <v-menu offset-y>
                              <template v-slot:activator="{ on, attrs }">
                                <v-btn
                                  color="primary"
                                  small
                                  dark
                                  v-bind="attrs"
                                  v-on="on"
                                >
                                  Opciones
                                </v-btn>
                              </template>
                              <v-list>
                                <v-list-item
                                  v-if="player.totalCupones > 0"
                                  @click="
                                    player.useRondaCupon =
                                      !player.useRondaCupon;
                                    setTarifaRodasSerie(
                                      player.useRondaCupon,
                                      index
                                    );
                                  "
                                >
                                  <v-list-item-title>
                                    <v-icon
                                      color="success"
                                      v-if="player.useRondaCupon"
                                      >mdi-check-circle</v-icon
                                    >
                                    Usar Ronda Prepago</v-list-item-title
                                  >
                                </v-list-item>
                                <v-list-item
                                  v-if="players.length > 1"
                                  @click="
                                    replicarJugador(
                                      player.tarifario,
                                      player.tarifa,
                                      player
                                    )
                                  "
                                >
                                  <v-list-item-title
                                    >Replicar Jugador</v-list-item-title
                                  >
                                </v-list-item>
                                <v-list-item
                                  v-if="players.length > 1"
                                  @click="
                                    replicarTarifa(
                                      player.tarifario,
                                      player.tarifa,
                                      player
                                    )
                                  "
                                >
                                  <v-list-item-title
                                    >Replicar Tarifa</v-list-item-title
                                  >
                                </v-list-item>

                                <v-list-item
                                  @click="player.useCupon = !player.useCupon"
                                >
                                  <v-list-item-title>
                                    <v-icon
                                      color="success"
                                      v-if="player.useCupon"
                                      >mdi-check-circle</v-icon
                                    >
                                    Cupón</v-list-item-title
                                  >
                                </v-list-item>
                                <v-list-item
                                  v-if="player.estatus == 'R'"
                                  @click="cancelarJugador(player, index, true)"
                                  class="red--text"
                                >
                                  <v-list-item-title>
                                    Cancelar Jugador</v-list-item-title
                                  >
                                </v-list-item>
                                <v-list-item
                                  v-if="player.estatus == 'C'"
                                  @click="cancelarJugador(player, index, false)"
                                  class="green--text"
                                >
                                  <v-list-item-title>
                                    Activar Jugador</v-list-item-title
                                  >
                                </v-list-item>
                                <v-list-item
                                  v-if="index != 0 && player.estatus != 'P'"
                                  @click="deletePlayer(index)"
                                  class="red--text"
                                >
                                  <v-list-item-title>
                                    Eliminar</v-list-item-title
                                  >
                                </v-list-item>
                              </v-list>
                            </v-menu>
                          </td>
                        </tr>
                      </template>
                    </tbody>
                  </v-simple-table>
                </v-form>
              </v-tab-item>
              <v-tab-item :eager="true" class="pa-2">
                <v-card
                  class="mx-2 my-2"
                  color="#e0e0e0"
                  elevation="0"
                  style=""
                >
                  <v-card-text>
                    <v-form ref="playersForm" class="my-2">
                      <template v-for="(player, index) in players">
                        <v-card
                          class="my-2"
                          :key="index"
                          v-if="showPlayer(player, index)"
                          v-show="
                            !editPlayers.edit || editPlayers.playerIdx == index
                          "
                        >
                          <div>
                            <v-card-text>
                              <v-row>
                                <v-col cols="12" md="12" class="mt-n2">
                                  <h4>
                                    Jugador {{ index + 1 }} -
                                    {{
                                      player.name == ""
                                        ? "Complete la información del jugador"
                                        : player.name
                                    }}
                                  </h4>
                                </v-col>
                                <v-col
                                  v-if="false"
                                  cols="12"
                                  md="12"
                                  class="mt-n4 mb-n3"
                                >
                                  <v-text-field
                                    @keypress="
                                      $pgsHelper.onlyNumber(
                                        $event,
                                        player.nCarrito
                                      )
                                    "
                                    v-model="player.nCarrito"
                                    label="Numero Carrito"
                                  ></v-text-field>
                                </v-col>

                                <v-col
                                  cols="12"
                                  md="12"
                                  v-if="player.esInvitado"
                                  class="mt-n2"
                                >
                                  <v-row class="mt-n6" v-if="player.esInvitado">
                                    <v-col md="12">
                                      <v-autocomplete
                                        v-model="player.IdMiembro"
                                        :items="comp_clients"
                                        item-value="Id"
                                        label="Invitado de:"
                                        @change="
                                          changeMiembroInvitado(player, index)
                                        "
                                      ></v-autocomplete>
                                      <v-alert
                                        v-if="
                                          !player.invitation.valid &
                                          (player.IdMiembro != '')
                                        "
                                        dense
                                        outlined
                                        type="error"
                                      >
                                        El miembro seleccionado no pude disponer
                                        de pases de invitado
                                      </v-alert>
                                      <v-alert
                                        v-if="
                                          player.invitation.valid &
                                          (player.IdMiembro != '')
                                        "
                                        dense
                                        outlined
                                        type="success"
                                      >
                                        Pase de invitado valido
                                      </v-alert>
                                    </v-col>
                                  </v-row>
                                </v-col>
                                <v-col
                                  cols="12"
                                  md="12"
                                  v-if="player.golfClub"
                                  class="mt-n2"
                                >
                                  <v-row class="mt-n6">
                                    <v-col v-if="player.golfClub">
                                      <v-label>Gender:</v-label>
                                      <v-select
                                        v-model="player.genero"
                                        :items="['Man', 'Woman']"
                                        outlined
                                        dense
                                      ></v-select>
                                    </v-col>

                                    <v-col v-if="player.golfClub">
                                      <v-label>Hand:</v-label>
                                      <v-select
                                        v-model="player.side"
                                        :items="
                                          player.genero === 'Man'
                                            ? ['left', 'right']
                                            : ['right']
                                        "
                                        outlined
                                        dense
                                      ></v-select>
                                    </v-col>

                                    <v-col
                                      v-if="
                                        player.golfClub &&
                                        player.genero === 'Man'
                                      "
                                      class="field"
                                    >
                                      <v-label>Shaft:</v-label>
                                      <v-select
                                        v-model="player.shaft"
                                        :items="['regular', 'stiff']"
                                        outlined
                                        dense
                                      ></v-select>
                                    </v-col>
                                  </v-row>
                                </v-col>
                              </v-row>
                            </v-card-text>
                          </div>
                        </v-card>
                      </template>
                    </v-form>
                  </v-card-text>
                </v-card>
              </v-tab-item>
            </v-tabs-items>
          </v-tab-item>
          <v-tab-item :eager="true" class="pa-2">
            <v-textarea label="Notas de la reserva" v-model="nota"></v-textarea>
          </v-tab-item>
          <v-tab-item :eager="true" class="pa-2">
            <h5>Seleccione unanAgencia (Opcional)</h5>
            <v-autocomplete
              :items="mayoristas.mayoristas"
              v-model="Mayorista.Id"
              @input="onChangeMayorista()"
              label="Agencia"
              item-text="Nombre"
              item-value="id"
            ></v-autocomplete>
            <h5>Seleccione un Concierge (Opcional)</h5>
            <v-autocomplete
              :items="concierges"
              v-model="Concierge.Id"
              @input="onChangeConcierge()"
              label="Concierge"
              item-text="nom"
              item-value="id"
            ></v-autocomplete>
          </v-tab-item>
          <v-tab-item :eager="true" class="pa-2">
            <TransportacionForm
              ref="transportacion"
              :key="tranindx"
              :paxNumber="this.players.length + this.cartRiders.length"
              :prefered="this.isPreferedTime"
              :fecha="this.input_date.format('YYYY-MM-DD')"
              :time="this.selectedTime"
              @onChangeTransportationData="setTransData"
            />
          </v-tab-item>
          <v-tab-item :eager="true">
            <v-row>
              <v-col md="8">
                <v-text-field
                  v-model="cartRiderName"
                  label="Nombre"
                ></v-text-field>
              </v-col>
              <v-col v-if="Addons.cartRider" md="4">
                <v-btn outlined color="green" @click="addCartRider" block
                  >Add + {{ Addons.cartRider.Precio }}
                  {{ Addons.cartRider.Moneda }}
                </v-btn>
              </v-col>
              <v-col md="12">
                <v-list dense>
                  <template v-for="(cartRider, index) in cartRiders">
                    <v-list-item :key="index">
                      <v-list-item-content>
                        <h3>Nombre: {{ cartRider.Nombre }}</h3>
                        <v-row>
                          <v-col>
                            <v-text-field
                              v-model="cartRider.Pco.C"
                              label="Precio"
                              dense
                            ></v-text-field>
                          </v-col>
                          <v-col>
                            <v-select
                              v-model="cartRider.Pco.M"
                              label="Moneda"
                              :items="getPDVMonedasLista"
                              item-value="id"
                              item-text="Nombre"
                              dense
                            >
                            </v-select>
                          </v-col>
                        </v-row>
                      </v-list-item-content>
                      <a
                        style="float: right"
                        @click="deleteCartRider(index)"
                        href="javascript:void(0);"
                        class="aligned"
                        ><i class="large close middle aligned icon"></i>
                      </a>
                    </v-list-item>
                  </template>
                </v-list>
              </v-col>
            </v-row>
          </v-tab-item>
        </v-tabs-items>
      </v-col>
    </v-row>
    <v-row>
      <v-col
        cols="12"
        sm="12"
        :md="!onlyEditPlayer ? 6 : 12"
        :g="!onlyEditPlayer ? 6 : 12"
        :xl="!onlyEditPlayer ? 6 : 12"
        :style="!onlyEditPlayer ? 'height: calc(100vh - 160px)' : ''"
      >
        <v-card
          v-if="false"
          class="mx-2 my-2"
          color="#e0e0e0"
          :style="
            !onlyEditPlayer ? 'height: calc(100vh - 40%); overflow: scroll' : ''
          "
          elevation="0"
        >
          <v-card-text>
            <v-form ref="playersForm" class="my-2">
              <template v-for="(player, index) in players">
                <v-card
                  class="my-2"
                  :key="index"
                  v-if="showPlayer(player, index)"
                >
                  <div>
                    <v-card-title>
                      Jugador {{ index + 1 }} -
                      {{
                        player.name == ""
                          ? "Complete la información del jugador"
                          : player.name
                      }}<br />

                      <v-chip color="red" small v-if="player.tarifa == ''">
                        Seleccione una tarifa para continuar
                      </v-chip>
                      <v-chip color="green" small v-if="player.TarifaSelected">
                        {{ player.TarifaSelected.Nombre }} -
                        {{ player.TarifaSelected.horarioNombre }} ${{
                          player.TarifaSelected.Precio
                        }}
                        {{ player.TarifaSelected.Moneda }}
                      </v-chip>
                    </v-card-title>
                    <v-card-text>
                      <v-row>
                        <v-col md="12">
                          <v-toolbar elevation="0" dense>
                            <v-card
                              v-if="false"
                              class="mx-1 d-flex align-center justify-center text-center btnCard"
                              @click="formClient++, (showModalCliente = true)"
                              width="70"
                              height="60"
                            >
                              <span>Agregar Cliente</span>
                            </v-card>
                            <v-card
                              v-if="players.length > 1 && index == 0"
                              :color="checkAsGuest ? 'primary' : ''"
                              :dark="checkAsGuest"
                              class="mx-1 d-flex align-center justify-center text-center btnCard"
                              @click="
                                checkAsGuest = !checkAsGuest;
                                changeAsGuest();
                              "
                              width="70"
                              height="60"
                            >
                              <span>Marcar Invitados</span>
                            </v-card>
                            <v-card
                              class="mx-1 d-flex align-center justify-center text-center btnCard"
                              @click="player.golfClub = !player.golfClub"
                              :color="player.golfClub ? 'primary' : ''"
                              :dark="player.golfClub"
                              width="70"
                              height="60"
                            >
                              <span
                                >Golf club +
                                {{
                                  Addons.golfClub.Precio +
                                  " " +
                                  Addons.golfClub.Moneda
                                }}</span
                              >
                            </v-card>
                            <v-card
                              v-show="!onlyEditPlayer"
                              v-if="players.length > 1 && index == 0"
                              class="mx-1 d-flex align-center justify-center text-center btnCard"
                              @click="
                                replicarTarifa(
                                  player.tarifario,
                                  player.tarifa,
                                  player
                                )
                              "
                              width="70"
                              height="60"
                            >
                              <span>Replicar Tarifa</span>
                            </v-card>
                            <v-card
                              v-show="!onlyEditPlayer"
                              v-if="players.length > 1 && index == 0"
                              class="mx-1 d-flex align-center justify-center text-center btnCard"
                              @click="
                                replicarJugador(
                                  player.tarifario,
                                  player.tarifa,
                                  player
                                )
                              "
                              width="70"
                              height="60"
                            >
                              <span>Replicar Jugador</span>
                            </v-card>
                            <v-card
                              class="mx-1 d-flex align-center justify-center text-center btnCard"
                              :color="player.esInvitado ? 'primary' : ''"
                              :dark="player.esInvitado"
                              @click="player.esInvitado = !player.esInvitado"
                              width="70"
                              height="60"
                            >
                              <span>Invitado</span>
                            </v-card>
                            <v-card
                              :color="player.useCupon ? 'primary' : ''"
                              @click="player.useCupon = !player.useCupon"
                              :dark="player.useCupon"
                              class="mx-1 d-flex align-center justify-center text-center btnCard"
                              width="70"
                              height="60"
                            >
                              <span>Cupón</span>
                            </v-card>
                            <v-card
                              v-if="player.totalCupones > 0"
                              :color="player.useRondaCupon ? 'primary' : ''"
                              :dark="player.useRondaCupon"
                              class="mx-1 d-flex align-center justify-center text-center btnCard"
                              width="70"
                              height="60"
                              @click="
                                player.useRondaCupon = !player.useRondaCupon;
                                setTarifaRodasSerie(
                                  player.useRondaCupon,
                                  index
                                );
                              "
                            >
                              <span>Ronda Prepago</span>
                            </v-card>
                            <v-card
                              color="green"
                              v-if="player.estatus == 'R'"
                              @click="
                                $router.push({
                                  path: '/sales-point/' + Id + '/' + index,
                                })
                              "
                              class="mx-1 d-flex align-center justify-center text-center btnCard white--text"
                              width="70"
                              height="60"
                            >
                              <span>Check In</span>
                            </v-card>
                          </v-toolbar>
                        </v-col>
                        <v-col cols="12" md="8">
                          player index {{ index }}
                          <div>
                            <v-combobox
                              :label="'Jugador'"
                              outlined
                              dense
                              v-model="player.dataClient"
                              :items="comp_clients"
                              item-value="Id"
                              @input="interceptorClient(player, index)"
                              :search-input.sync="player.name"
                            >
                              <template v-slot:item="data">
                                <v-list-item-content>
                                  {{ data.item.text }}<br />
                                  <b v-if="data.item.esMiembro"
                                    ><v-icon small color="yellow">
                                      mdi-star
                                    </v-icon>
                                    Miembro</b
                                  >
                                </v-list-item-content>
                              </template>
                            </v-combobox>
                          </div>
                        </v-col>
                        <v-col cols="12" md="4">
                          <div>
                            <v-btn
                              @click="
                                indexItem = index;
                                idx.formClient++;
                                showModalCliente = true;
                              "
                              block
                              outlined
                              :color="$pgsHelper.uiConfig().mainColor"
                            >
                              Nuevo Cliente
                            </v-btn>
                          </div>
                        </v-col>
                        <v-col
                          v-if="!player.useRondaCupon"
                          cols="6"
                          md="6"
                          class="mt-n6"
                        >
                          <v-autocomplete
                            :items="tarifaCombo"
                            outlined
                            dense
                            v-model="player.tarifario"
                            @input="getTarifasByTarifario(index)"
                            label="Seleccione un tarifario"
                          >
                          </v-autocomplete>
                        </v-col>
                        <v-col
                          v-if="!player.useRondaCupon"
                          cols="6"
                          md="6"
                          class="mt-n6"
                        >
                          <v-autocomplete
                            :items="player.listadoTarifas"
                            outlined
                            dense
                            v-model="player.tarifa"
                            @input="getTarifasByPlayer(index)"
                            :rules="Rules.Tarifa"
                            label="Seleccione una Tarifa"
                          >
                            <template v-slot:item="data">
                              <v-list-item-content>
                                <v-list-item-title>
                                  {{ data.item.tarifarioName }}
                                  {{ data.item.text }}</v-list-item-title
                                >
                                <v-list-item-subtitle
                                  >{{ data.item.nombreHorario }} ${{
                                    data.item.Precio
                                  }}</v-list-item-subtitle
                                >

                                <v-list-item-subtitle
                                  >{{ data.item.temporadaName }} :
                                  {{
                                    $pgsHelper
                                      .getDate(data.item.Inicio)
                                      .format("DD/MM/YYYY")
                                  }}
                                  -
                                  {{
                                    $pgsHelper
                                      .getDate(data.item.Final)
                                      .format("DD/MM/YYYY")
                                  }}</v-list-item-subtitle
                                >
                              </v-list-item-content>
                            </template>
                          </v-autocomplete>
                        </v-col>
                        <v-col cols="12" md="12" class="mt-n8">
                          <v-row class="mt-n6" v-if="player.esInvitado">
                            <v-col md="12">
                              <v-autocomplete
                                v-model="player.IdMiembro"
                                :items="comp_clients"
                                item-value="Id"
                                label="Invitado de:"
                                @change="changeMiembroInvitado(player, index)"
                              ></v-autocomplete>
                              <v-alert
                                v-if="
                                  !player.invitation.valid &
                                  (player.IdMiembro != '')
                                "
                                dense
                                outlined
                                type="error"
                              >
                                El miembro seleccionado no pude disponer de
                                pases de invitado
                              </v-alert>
                              <v-alert
                                v-if="
                                  player.invitation.valid &
                                  (player.IdMiembro != '')
                                "
                                dense
                                outlined
                                type="success"
                              >
                                Pase de invitado valido
                              </v-alert>
                            </v-col>
                          </v-row>
                        </v-col>
                        <v-col cols="12" md="12" class="mt-n8">
                          <v-row class="mt-n6">
                            <v-col v-if="player.golfClub">
                              <v-label>Gender:</v-label>
                              <v-select
                                v-model="player.genero"
                                :items="['Man', 'Woman']"
                                outlined
                                dense
                              ></v-select>
                            </v-col>

                            <v-col v-if="player.golfClub">
                              <v-label>Hand:</v-label>
                              <v-select
                                v-model="player.side"
                                :items="
                                  player.genero === 'Man'
                                    ? ['Left', 'Right']
                                    : ['Right']
                                "
                                outlined
                                dense
                              ></v-select>
                            </v-col>

                            <v-col
                              v-if="player.golfClub && player.genero === 'Man'"
                            >
                              <v-label>Shaft:</v-label>
                              <v-select
                                v-model="player.shaft"
                                :items="['Regular', 'Stiff']"
                                outlined
                                dense
                              ></v-select>
                            </v-col>
                          </v-row>
                        </v-col>
                      </v-row>
                      <div v-bind:key="index">
                        <div
                          v-if="player.useRondaCupon == false"
                        ></div>
                      </div>
                    </v-card-text>
                    <v-card-actions>
                      <v-btn
                        v-if="player.estatus == 'R'"
                        color="red"
                        @click="cancelarJugador(player, index, true)"
                        text
                      >
                        Cancelar Jugador
                      </v-btn>

                      <v-btn
                        v-if="player.estatus == 'C'"
                        color="green"
                        @click="cancelarJugador(player, index, false)"
                        text
                      >
                        Activar Jugador
                      </v-btn>
                    </v-card-actions>
                  </div>
                </v-card>
              </template>
            </v-form>
          </v-card-text>
        </v-card>
        <div
          v-bind:style="{ position: !onlyEditPlayer ? 'fixed !important' : '' }"
          style="bottom: 0 !important"
          v-bind:class="{ bottomPanel: !onlyEditPlayer }"
        >
          <v-card style="height: 150px" elevation="0">
            <v-card-text>
              <v-alert
                v-show="!onlyEditPlayer"
                style=""
                icon="mdi-currency-usd"
                type="info"
                text
              >
                <h5 v-if="typePaid == 1">Prepagado</h5>
                <h5 v-if="typePaid == 2">
                  Total USD:${{
                    $pgsHelper.formatNumber(grandTotal.total)
                  }}
                  Total MXN:${{
                    $pgsHelper.formatNumber(grandTotal.totalPesos)
                  }}
                </h5>
              </v-alert>
              <v-row class="mt-2 mb-n8">
                <v-col md="6" cols="6"
                  ><v-btn
                    v-show="!onlyEditPlayer"
                    @click="onChangeStatus()"
                    v-if="loadingData == false"
                    color="error"
                  >
                    Cancelar Reserva
                  </v-btn></v-col
                >
                <v-col md="6" cols="6"
                  ><v-btn
                    :loading="loadindAction"
                    @click="buildReservationData()"
                    v-if="loadingData == false && editingTimeDate == false"
                    color="success"
                  >
                    Guardar Edición
                  </v-btn>
                </v-col>

                <v-col></v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </div>
      </v-col>
    </v-row>

    <!--<div class="big ui right aligned primary button full-button" @click="$router.push({path:'/proshop/menu'})" style="float: right; margin-top: 10px;"><i class="reply icon" ></i>Regresar </div>-->

    <modal
      v-model="showModalCliente"
      :showFooter="false"
      title="Agregar Cliente"
    >
      <FormClientes
        :edit="false"
        :key="idx.formClient"
        @toggle="showModalCliente = false"
        :dataEdit="{}"
      ></FormClientes>
    </modal>
    <v-dialog v-model="sendConfirmModal" persistent max-width="290">
      <v-card>
        <v-card-title class="text-h5"> Enviar Confirmación </v-card-title>
        <v-card-text>
          <v-text-field
            v-model="confirmationMail"
            label="Correo"
          ></v-text-field>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="green darken-1" text @click="sendConfirmModal = false">
            Cancelar
          </v-btn>
          <v-btn
            :loading="sendingMail"
            color="green darken-1"
            text
            @click="sendConfirmationMale()"
          >
            Enviar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="showModalEvaliv" persistent max-width="500">
      <EvalivInterceptor
        :cliente="clienteEvaliv"
        :edit="false"
        :key="evalivIndex"
        :indexItem="indexPlayerEvaliv"
        @rechazarCliente="rechazarCliente"
        @aceptarCliente="aceptarCliente"
        @toggle="showModalEvaliv = false"
        :dataEdit="{}"
      ></EvalivInterceptor>
    </v-dialog>
    <v-dialog v-model="editingTimeDate" persistent max-width="590">
      <v-card>
        <v-card-title v-show="editingTimeDate">
          Actual: {{ input_date.format("dddd DD [de] MMMM [de] YYYY") }} Hora:
          {{ selectedTime }} - {{ selectedTimeEnd }}
        </v-card-title>
        <v-card-text v-show="editingTimeDate">
          <v-row>
            <v-col class="display-3" cols="12">
              <v-menu
                v-show="editingTimeDate"
                ref="menu"
                :close-on-content-click="false"
                :return-value.sync="date"
                transition="scale-transition"
                offset-y
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-show="editingTimeDate"
                    v-model="date"
                    label="Fecha Seleccionada"
                    prepend-icon="mdi-calendar"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="date"
                  @change="updateSelectedDate()"
                  @update:picker-date="pickerUpdate($event)"
                  no-title
                  scrollable
                >
                  <v-spacer></v-spacer>
                  <v-btn text color="primary" @click="menu = false">
                    Cancel
                  </v-btn>
                  <v-btn text color="primary" @click="$refs.menu.save(date)">
                    OK
                  </v-btn>
                </v-date-picker>
              </v-menu>
            </v-col>
            <v-col class="display-3" cols="12">
              <div class="field">
                <datetime
                  v-show="editingTimeDate"
                  type="time"
                  input-id="iniTime"
                  v-model="timeEdit"
                  :auto="false"
                  :format="{ hour: 'numeric', minute: '2-digit' }"
                  :minute-step="10"
                >
                </datetime>
                <datetime
                  v-show="editingTimeDate"
                  type="time"
                  input-id="iniTime"
                  v-model="timeEndEdit"
                  :min-datetime="timeEdit"
                  :auto="false"
                  :format="{ hour: 'numeric', minute: '2-digit' }"
                  :minute-step="30"
                ></datetime>
              </div>
            </v-col>
            <v-col cols="12">
              Seleccione un Espacio (Bahia,Cancha,Instructor)
              <v-chip-group class="mx-2" column>
                <template v-for="(bahia, index) in comp_bahias">
                  <v-chip
                    :key="index"
                    @click="Bahia = index + 1"
                    v-bind:class="[Bahia == index + 1 ? 'primary' : '']"
                    >{{ bahia.Name }}</v-chip
                  >
                </template>
              </v-chip-group>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="green darken-1" text @click="editingTimeDate = false">
            Cancelar
          </v-btn>
          <v-btn color="green darken-1" text @click="validarDisponibilidad()">
            Verificar disponibilidad
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="showHistory" persistent max-width="800">
      <PlayerHistoriCard
        @close="showHistory = false"
        :key="indexHistory"
        :player="historyclient"
      ></PlayerHistoriCard>
    </v-dialog>
  </div>
</template>

<script>
import moment from "moment";

import { mapGetters } from "vuex";
import TarifasClass from "../../../clases/Tarifa.js";
import modal from "../../MainComponents/modal.vue";
import EvalivInterceptor from "../EvalivInterceptor.vue";
import TransportacionForm from "../TransportacionForm.vue";
import MembresiaClass from "../../../clases/Membresias/Membresia.js";
import FormClientes from "../../Clientes/Clientes/ClienteForm.vue";
import Cliente from "../../../clases/Cliente.js";
import ReservaClass from "../../../clases/Reserva.js";
import PlayerHistoriCard from "../PlayerHistoriCard.vue";
import { UID } from "../../../clases/UID.js";
export default {
  name: "BookingActivityEditForm",
  components: {
    PlayerHistoriCard,
    modal,
    FormClientes,
    TransportacionForm,
    EvalivInterceptor,
  },
  props: [
    "selectedT",
    "editMode",
    "editData",
    "daysRules",
    "tarifaCombo",
    "onlyEditPlayer",
    "indexPlayerEdit",
    "loadindAction",
    "Concierges",
    "rvaDepto",
    "maxPlayers",
    "slotsNumber",
  ],
  data() {
    return {
      Invitados: 0,
      Bahia: "",
      indexHistory: 0,
      showHistory: false,
      historyclient: null,
      sendingMail: false,
      confirmationMail: "",
      sendConfirmModal: false,
      loadingContent: false,
      plyTabs: 0,
      extraTabs: 0,
      Folio: "",
      ConfigRva: null,
      Rules: ReservaClass.getRules(),
      idx: {
        formClient: 0,
      },
      typePaid: "2",
      editingTimeDate: false,
      timeEdit: "",
      timeEndEdit: "",
      date: "",
      Id: "",
      doAction: "",
      reservaEdit: {},
      input_date: new moment(),
      MainDepartamento: "Golf",
      selectedTime: "",
      selectedTimeEnd: "",
      availableDates: [],
      allowPlayers: 0,
      playersNumber: 1,
      modalidad: "",
      checkAsGuest: false,
      players: [],
      editPlayers: {
        edit: false,
        playerIdx: "",
      },
      nota: "",
      cajeros: [],
      temporadas: [],
      //tarifaCombo: [],
      tiposJuego: [],
      subcategorias: [],
      gruposCliente: [],
      Horarios: [],
      guessConfig: {},
      cartRiders: [],
      confirmBook: false,
      transModal: false,
      showModalCliente: false,
      modalOpen: false,
      isAdmin: false,
      Transportacion: null,
      Mayorista: {
        Id: null,
        Nm: "",
      },
      Concierge: {
        Id: null,
        Nm: "",
      },
      loadingData: false,
      private_reservation: false,
      Session: "",
      ApiToken: "",
      TotalTrans: 0,
      RowId: "",
      DuracionViaje: "",
      rawDuracionViaje: "",
      HtlPickup: "",
      PCGCPickup: "",
      tranindx: 1,
      isPreferedTime: false,
      cartRiderName: "",
      clienteEvaliv: null,
      showModalEvaliv: false,
      evalivIndex: 0,
      indexPlayerEvaliv: 0,
      clientAdd: {
        nombre: "",
        apellidos: "",
        correo: "",
        telefono: "",
        grupo: "",
        tipoMembresia: "",
      },
      errors: {
        time: false,
        players: false,
        code: false,
      },
    };
  },
  methods: {
    showPlayer(player, index) {
      if (player.estatus != "P") {
        if (this.onlyEditPlayer) {
          if (Number(index) == Number(this.indexPlayerEdit)) {
            return true;
          } else {
            return false;
          }
        } else {
          return true;
        }
      } else {
        return false;
      }
    },
    interceptorClient(player, index) {
      let tenant = this.$store.getters.getFirebaseApp.tenant;

      if (tenant === "PCUN") {
        //this.setPlayerData(player, index)
        if (player?.dataClient?.Id) {
          this.clienteEvaliv = this.$pgsHelper.cloneObj(player);

          this.indexPlayerEvaliv = index;
          this.evalivIndex++;
          this.showModalEvaliv = true;
        } else {
          this.setPlayerData(player, index);
        }
      } else {
        this.setPlayerData(player, index);
      }
    },
    rechazarCliente(data) {
      this.players[data.index].isClient = false;
      this.players[data.index].name = "";
      this.players[data.index].dataClient = "";

      this.showModalEvaliv = false;
    },
    aceptarCliente(data) {
      this.players[data.index].dataClient = this.clienteEvaliv.dataClient;
      this.players[data.index].isAdeudo = data.isAdeudo;
      this.players[data.index].esInvitado = false;

      this.setPlayerData(this.players[data.index], data.index);
      this.showModalEvaliv = false;
    },
    async replicarTarifa(tarifario, tarifa, player) {
      if (tarifa != "") {
        this.players.forEach(async (element, index) => {
          if (index != 0) {
            element.tarifario = tarifario;
            await this.getTarifasByTarifario(index);
            element.tarifa = tarifa;
            this.getTarifasByPlayer(index);
          }
        });
      }
    },
    async replicarJugador(tarifario, tarifa, player) {
      this.players.forEach(async (element, index) => {
        if (index != 0) {
          element.isClient = player.isClient;
          element.dataClient = player.dataClient;
          element.IdCliente = player.IdCliente;
          element.name = player.name;
        }
      });
    },
    async validarDisponibilidad() {
      this.loadingData = true;
      let dateReserva = moment(this.editData.RF.FI, "YYYY-MM-DD_HH:mm:ss");

      let data = {
        Departamento: this.rvaDepto,
        FechaI: this.date + "_" + moment(this.timeEdit).format("HH:mm"),
        Pax: this.players.length,
        IdReserva: this.editData.id,
      };

      this.input_date = moment(this.date, "YYYY-MM-DD");
      this.selectedTime = moment(this.timeEdit).format("HH:mm");

      this.selectedTimeEnd = moment(this.timeEndEdit).format("HH:mm");

      this.changeModalidad();
      this.editingTimeDate = false;
      /*let dataAvailability = await this.$store.getters.getFirebaseApp.fba
          .call("RVA-Reservas-getAvailability", data, {})
          .then((result) => {
            if (result.data.ok) {
              if (result.data.data.Available) {
                this.input_date = moment(this.date, "YYYY-MM-DD");
                this.selectedTime = moment(this.timeEdit).format("HH:mm");
                this.changeModalidad();
                this.editingTimeDate = false;
              } else {
                this.$swal(
                  "La fecha y hora seleccionada no estan disponibles ",
                  "Seleccione una fecha y hora con disponibilidad ",
                  "error"
                );
              }
            }
          })
          .catch((error) => {
            this.$pgsHelper.log(error, true);
          });*/
      // this.input_date = moment(this.date,'YYYY-MM-DD');

      this.loadingData = false;
    },
    formatDate(timestamp) {
      let d = new Date(timestamp);
      //console.log(new moment(d))
      //let Creacion =   d.getDate()  + "-" + (d.getMonth()+1) + "-" + d.getFullYear() + " " + d.getHours() + ":" + d.getMinutes();
      return new moment(d).format("DD-MM-YYYY HH:mm");
    },
    updateSelectedDate() {
      //this.input_date = moment(this.date,'YYYY-MM-DD');
    },
    getInfoCajero(id) {
      let cajero = this.$pgsHelper.getById(this.cajeros, "Id", id);
      if (cajero) {
        return cajero.Nomb + " " + cajero.NCjr;
      }
      return "";
    },
    async getCajeros() {
      const snapshot =
        await this.$store.getters.getFirebaseApp.database.queryBuilder(
          "PDV/Cajeros"
        );

      if (snapshot.exists()) {
        this.cajeros = [];
        Object.keys(snapshot.val()).forEach((id) => {
          const toAdd = snapshot.val()[id];
          if (toAdd) {
            toAdd.Id = id;
            // ajustar usuarios antiguos
            this.cajeros.push(toAdd);
          }
        });
      }
    },
    async sendConfirmationMale() {
      this.sendingMail = true;
      await this.$store.getters.getFirebaseApp.fba
        .call("RVA-Reservas-enviarConfirmacion", {
          RVAId: this.editData.id,
          To: this.confirmationMail,
        })
        .then((result) => {
          if (result.data.ok) {
            this.sendingMail = false;
            this.sendConfirmModal = false;
          } else {
            this.sendingMail = false;
            this.$swal("Error enviando el correo", result.data.error, "error");
          }
        })
        .catch((error) => {
          this.sendingMail = false;
          this.$swal.showValidationMessage(`Request failed: ${error}`);
        });
    },
    pickerUpdate(val) {
      let totalDay = moment(val, "YYYY-MM").daysInMonth();
      let weekDay = [];

      let disable_dates = [];
      let open_dates = [];

      this.daysRules.forEach((element) => {
        if (element.data === false) {
          disable_dates.push(element.date, "YYYY-MM-DD");
        } else {
          open_dates.push(element.date);
        }
      });

      let availableDates = [];

      let monthNow = moment().format("M");
      let monthSelected = moment(val).format("M");
      let day;

      if (monthNow == monthSelected) day = moment().format("D");
      else day = 1;

      for (let i = day; i <= totalDay; i++) {
        let date = moment()
          .month(val.split("-")[1] - 1)
          .date(i)
          .format("YYYY-MM-DD");
        if (
          !weekDay.includes(moment(date).day()) &&
          !disable_dates.includes(date)
        ) {
          availableDates.push(date);
        }

        if (weekDay.includes(moment(date).day()) && open_dates.includes(date)) {
          availableDates.push(date);
        }
      }
      this.availableDates = availableDates;
      this.allowedDates();
    },
    allowedDates(a) {
      return this.availableDates.includes(a);
    },
    init() {
      this.getTiposJuego()
        .then(() => {
          return this.getTemporadas();
        })
        .then(async () => {
          await this.getHorarios();
          await this.getSubcategoria();
          //await this.getTarifarios();
        });
    },
    validateClientForm() {
      let valid = true;
      if (this.clientAdd.nombre == "") {
        valid = false;
      }

      if (this.clientAdd.apellidos == "") {
        valid = false;
      }

      if (this.clientAdd.email == "") {
        valid = false;
      }

      return valid;
    },
    async getHorarios() {
      this.Horarios = [];
      const data =
        await this.$store.getters.getFirebaseApp.database.queryBuilder(
          "RVA/Tarifas/" + this.rvaDepto + "/Horarios"
        );

      if (!data.exists()) {
        return false;
      }
      let arrayHorarios = Object.entries(data.val());
      var $this = this;
      arrayHorarios.forEach(function (element) {
        $this.Horarios.push({ id: element[0], ...element[1] });
      });
    },
    async getSubcategoria() {
      const data =
        await this.$store.getters.getFirebaseApp.database.queryBuilder(
          "RVA/Tarifas/" + this.rvaDepto + "/SubCategorias"
        );
      if (!data.exists()) {
        return false;
      }
      let arrayHoteles = Object.entries(data.val());

      arrayHoteles.forEach((element) => {
        this.subcategorias.push({
          id: element[0],
          key: element[0],
          text: element[1].Nombre,
          value: element[0],
          ...element[1],
        });
      });
    },
    async getTiposJuego() {
      const data =
        await this.$store.getters.getFirebaseApp.database.queryBuilder(
          "RVA/Tarifas/" + this.rvaDepto + "/Modalidades"
        );

      let arrayTipos = Object.entries(data.val());
      var $this = this;
      arrayTipos.forEach((element) => {
        this.tiposJuego.push({
          id: element[0],
          codigo: element[1]["Codigo"],
          nombre: element[1]["Nombre"],
        });
      });
    },
    async getTemporadas() {
      /*
        Obtiene las temporadas existentes en la db
        */
      const data =
        await this.$store.getters.getFirebaseApp.database.queryBuilder(
          "RVA/Tarifas/" + this.rvaDepto + "/Temporadas"
        );
      if (!data.exists()) {
        return false;
      }
      let arrayTarifas = Object.entries(data.val());
      arrayTarifas.forEach((element) => {
        if (element[1].Activo) {
          this.temporadas.push({ id: element[0], ...element[1] });
        }
      });
    },
    changeModalidad() {
      this.players.forEach(async (player, index) => {
        await this.getTarifasByTarifario(index);
        await this.getTarifasByPlayer(index);
      });
    },
    changePlayersNumber() {
      //this.players= [{name:'',email:'',phone:'',golfClub:false,side:"right",genero:'Man',shaft:'regular'}];
      if (this.players.length < this.playersNumber) {
        var i;
        for (i = this.players.length; i < this.playersNumber; i++) {
          this.players.push({
            isAdeudo: false,
            listadoTarifas: [],
            tarifario: "",
            totalCupones: 0,
            useRondaCupon: false,
            dataClient: "",
            cuponSelected: "",
            combo_cupon: [],
            formMayorista: "",
            useCupon: false,
            esInvitado: false,
            IdMiembro: "",
            invitation: { valid: false },
            name: "",
            email: "",
            phone: "",
            golfClub: false,
            side: "right",
            genero: "Man",
            shaft: "regular",
            tarifa: "",
            isClient: false,
            TarifaSelected: "",
            IdCliente: " ",
            hdcp: "",
            nCarrito: "",
            Precio: 0,
          });
        }
      } else if (this.players.length > this.playersNumber) {
        for (i = this.playersNumber; i < this.players.length; i) {
          this.players.pop();
        }
      }
    },
    editPlayer(index) {
      this.editPlayers.edit = !this.editPlayers.edit;
      this.editPlayers.playerIdx = index;
    },
    async setPlayerData(player, index = null) {
      if (player.dataClient.Id) {
        player.isClient = true;
        player.IdCliente = player.dataClient.Id;
        player.name =
          player.dataClient.Apellidos + " " + player.dataClient.Nombres;
        player.email = player.dataClient.Correo;

        let dataCupones = [];
        let totalCupones = 0;
        if (player.dataClient.Cupones) {
          player.dataClient.Cupones.sort(function (a, b) {
            // Turn your strings into dates, and then subtract them
            // to get a value that is either negative, positive, or zero.
            return new Date(b.Exp.FT) - new Date(a.Exp.FT);
          });
          let arrayCupones = player.dataClient.Cupones.filter((cpn) => {
            return cpn.Cupon.Subtipo === "Rondas" && cpn.Exp.ES === "A";
          });
          arrayCupones.forEach((serie) => {
            for (let index = 0; index < serie.Con.Disponibles; index++) {
              totalCupones++;
              serie.Cupon.CCI = serie._CCI;
              dataCupones.push(serie.Cupon);
            }
          });
          player.dataClient.Cupones.forEach((serie) => {
            for (let index = 0; index < serie.Con.Disponibles; index++) {
              totalCupones++;
              serie.Cupon.CCI = serie._CCI;
              dataCupones.push(serie.Cupon);
            }
          });
        }
        player.totalCupones = totalCupones;
        player.dataClient.dataCupones = dataCupones;
        // player.dataClient = player.IdCliente;
        player.dataCupones = dataCupones;
        player.PlanMemebresia = null;
        if (!player.useRondaCupon) {
          if (player.dataClient.ExtraData) {
            if (player.dataClient.ExtraData.Membresia) {
              if (player.dataClient.ExtraData.Membresia.Membresia) {
                let membresiaCliente = await MembresiaClass.getById(
                  player.dataClient.ExtraData.Membresia.Membresia
                );
                if (membresiaCliente) {
                  let planMembresia = await membresiaCliente.getPlan();
                  player.PlanMemebresia = planMembresia.Id;
                }
              }
            }
          }
        }
        //if (index) {
        /*if(!player.useRondaCupon){
            if (player.dataClient.ExtraData) {
              if (player.dataClient.ExtraData.Membresia) {
                if (player.dataClient.ExtraData.Membresia.Membresia) {
                  let membresiaCliente = await MembresiaClass.getById(
                    player.dataClient.ExtraData.Membresia.Membresia
                  );
                  let planMembresia = await membresiaCliente.getPlan();
                  let beneficios = await planMembresia.getBeneficios();

                  beneficios.Beneficios.forEach(async (beneficio) => {
                    if (beneficio.Tipo == "RVA") {
                      if (beneficio.Departamento == this.rvaDepto) {
                        //valida si el beneficio es ilimitado y si no si aun puede usarse
                        if (beneficio.Cantidad) {
                          let contador =
                            membresiaCliente.getContadoresByClientIndex(
                              membresiaCliente.Clientes[player.IdCliente]
                            )[beneficios.IDX].U;
                          if (beneficio.Cantidad <= contador) {
                            return false;
                          }
                        }
                        //si el beneficio es valido, setea la tarifa que indica el beneficio
                        player.tarifario = beneficio.Tarifario;
                        await this.getTarifasByTarifario(index);
                        let tarifa = "";
                        player.listadoTarifas.forEach((tar) => {
                          if (
                            tar.data.Subcategoria[0] == beneficio.SubCategoria
                          ) {
                            tarifa = tar;
                          }
                        });
                        if (tarifa != "") {
                          player.tarifa = tarifa.value;
                          await this.getTarifasByPlayer(index);
                        }
                      }
                    }
                  });

                }
              }
            }
          }*/
        //}
      } else {
        player.IdCliente = null;
        player.isClient = false;
        player.name = player.dataClient;
        player.PlanMemebresia = null;
      }
      await this.getTarifasByTarifario(index);
    },
    async changeMiembroInvitado(player, index) {
      let cliente = this.$pgsHelper.getById(
        this.data_clientes,
        "Id",
        player.IdMiembro
      );
      player.invitation.valid = false;
      if (cliente.ExtraData) {
        if (cliente.ExtraData.Membresia) {
          if (cliente.ExtraData.Membresia.Membresia) {
            let membresiaCliente = await MembresiaClass.getById(
              cliente.ExtraData.Membresia.Membresia
            );
            let planMembresia = await membresiaCliente.getPlan();
            let beneficios = await planMembresia.getBeneficios();
            beneficios.Beneficios.forEach(async (beneficio) => {
              if ((beneficio.Tipo == "RVA") & beneficio.EsInvitado) {
                if (beneficio.Departamento == this.rvaDepto) {
                  //valida si el beneficio es ilimitado y si no si aun puede usarse
                  if (beneficio.Cantidad) {
                    let contadores =
                      await membresiaCliente.getContadoresByClientIndex(
                        membresiaCliente.Clientes[player.IdMiembro]
                      );
                    let contador = contadores[beneficio.IDX]
                      ? contadores[beneficio.IDX].U
                      : 0;
                    if (beneficio.Cantidad <= contador) {
                      player.invitation.valid = false;
                      this.$swal(
                        "El miembro seleccionado utilizo el total del beneficio"
                      );
                      return false;
                    }
                  }
                  //si el beneficio es valido, setea la tarifa que indica el beneficio
                  player.tarifario = beneficio.Tarifario;
                  await this.getTarifasByTarifario(index);
                  let tarifa = "";
                  player.listadoTarifas.forEach((tar) => {
                    if (tar.data.Subcategoria[0] == beneficio.SubCategoria) {
                      tarifa = tar;
                    }
                  });
                  if (tarifa != "") {
                    player.tarifa = tarifa.value;
                    await this.getTarifasByPlayer(index);
                    player.invitation.valid = true;
                    player.invitation.miembro = player.IdMiembro;
                    player.invitation.beneficio = beneficio.IDX;
                    player.invitation.membresia =
                      cliente.ExtraData.Membresia.Membresia;
                    player.invitation.plan = planMembresia.Id;
                  }
                }
              }
            });
          }
        }
      }
    },
    async getTarifarios() {
      let tarifarios = await TarifasClass.getMixTarifasCombo("Golf");
      tarifarios.forEach((element) => {
        element.value = element.Id;
        element.text = element.Nombre;
      });
      //this.tarifaCombo = tarifarios;
    },
    async getTarifasByTarifario(indexPly) {
      if (this.players[indexPly].useRondaCupon) {
        return false;
      }
      let idTemporada = "";
      let temporadasAplicables = [];
      this.temporadas.forEach((element) => {
        if (
          moment(element.FechaInicio).format("YYYY-MM-DD") <=
            this.input_date.format("YYYY-MM-DD") &&
          moment(element.FechaTermino).format("YYYY-MM-DD") >=
            this.input_date.format("YYYY-MM-DD")
        ) {
          temporadasAplicables.push(element.id);
          idTemporada = element.id;
        }
      });
      let TarifasCombo = [];
      let TarifasList = []; // new method
      let taskTarifas = temporadasAplicables.map(async (id) => {
        let tarifas = await TarifasClass.getMixTarifasByTarifarioParse(
          this.players[indexPly].tarifario,
          id,
          this.rvaDepto,
          this.Horarios,
          this.temporadas,
          this.tiposJuego,
          this.input_date.day()
        );
        tarifas.forEach((tar) => {
          TarifasList.push(tar);
        });
      });
      await Promise.all(taskTarifas).then(() => {
        TarifasList.forEach((tarifa, index) => {
          let nameTarifa = "Tarifa: ";
          let categoriaId = null;
          let categoriaName = null;

          tarifa.Subcategoria.forEach((element) => {
            categoriaId = element;
            nameTarifa +=
              this.$pgsHelper.getById(this.subcategorias, "id", element)
                .Nombre + " ";
            categoriaName = this.$pgsHelper.getById(
              this.subcategorias,
              "id",
              element
            ).Nombre;
          });
          let nombreHorario = "";
          let Precio = 0;
          let PrecioCon = 0;
          if (tarifa.arrayPrecios) {
            tarifa.arrayPrecios.forEach((modalidad) => {
              if (modalidad.id == this.modalidad) {
                modalidad.horarios.forEach((horario) => {
                  if (
                    moment(horario.data.HoraTermino, "HH:mm:ss").format(
                      "HH:mm"
                    ) >= moment(this.selectedTime, "HH:mm").format("HH:mm") &&
                    moment(horario.data.HoraInicio, "HH:mm:ss").format(
                      "HH:mm"
                    ) <= moment(this.selectedTime, "HH:mm").format("HH:mm")
                  ) {
                    nombreHorario = horario.data.Nombre;
                    (Precio = horario.PcoVen + " " + horario.Moneda),
                      (PrecioCon = horario.PcoCon + " " + horario.Moneda),
                      /*this.players[index].TarifaSelected = {
                      Tarifa: tarifa,
                      Nombre: tarifa.text,
                      TarifaId: tarifa.value,
                      Horario: horario,
                      horarioNombre: horario.data.Nombre,
                      tarifarioNombre: tarifarioData.Nombre,
                      Precio: horario.PcoVen,
                      PrecioCon: horario.PcoCon,
                      Moneda: horario.Moneda,
                    };*/

                      this.$forceUpdate();
                  }
                });
              }
            });
          }
          let tarifaValida = true;
          if (!tarifa.SoloPlanes) {
            tarifaValida = true;
          } else {
            if (this.players[indexPly].PlanMemebresia) {
              if (
                tarifa.SoloPlanes.includes(
                  this.players[indexPly].PlanMemebresia
                )
              ) {
                tarifaValida = true;
              } else {
                tarifaValida = false;
              }
            } else {
              tarifaValida = false;
            }
          }
          if (tarifaValida) {
            TarifasCombo.push({
              value: tarifa.id,
              text: nameTarifa,
              data: tarifa,
              Turista: tarifa.Turista || false,
              Iid: tarifa.Iid || null,
              Color: tarifa.Color || null,
              nombreHorario: nombreHorario,
              Precio: Precio,
              PrecioCon: PrecioCon,
              tarifarioName: this.$pgsHelper.getById(
                this.tarifaCombo,
                "value",
                tarifa.Tarifario
              ).text,
              Inicio: this.$pgsHelper.getById(
                this.temporadas,
                "id",
                tarifa.Temporada
              ).FechaInicio,
              Final: this.$pgsHelper.getById(
                this.temporadas,
                "id",
                tarifa.Temporada
              ).FechaTermino,
              temporadaName: this.$pgsHelper.getById(
                this.temporadas,
                "id",
                tarifa.Temporada
              ).Nombre,
              cateTarifa: {
                id: categoriaId,
                nombre: categoriaName,
              },
            });
          }
          if (this.players[indexPly].TarifaSelected) {
            if (this.players[indexPly].TarifaSelected?.TarifaId == tarifa.id) {
              if (!tarifaValida) {
                this.players[indexPly].TarifaSelected = "";
              }
            }
          }
        });
        this.players[indexPly].listadoTarifas = TarifasCombo;
      });
    },
    async getTarifasByPlayer(index, customPrice = null) {
      try {
        if (this.players[index].useRondaCupon) {
          return false;
        }
        let idTemporada = 0;
        let idTarifa = this.players[index].tarifa;
        let tarifa = this.$pgsHelper.getById(
          this.players[index].listadoTarifas,
          "value",
          idTarifa
        );
        let tarifarioData = this.$pgsHelper.getById(
          this.tarifaCombo,
          "value",
          this.players[index].tarifario
        );

        this.players[index].TarifaSelected = "";
        this.players[index].Precio = "";
        if (tarifa.data) {
          tarifa.data.arrayPrecios.forEach((modalidad) => {
            if (modalidad.id == this.modalidad) {
              if (modalidad.horarios.length == 0) {
                this.players[index].TarifaSelected = "";
                this.players[index].Precio = "";
              }
              modalidad.horarios.forEach((horario) => {
                if (
                  moment(horario.data.HoraTermino, "HH:mm:ss").format(
                    "HH:mm"
                  ) >= moment(this.selectedTime, "HH:mm").format("HH:mm") &&
                  moment(horario.data.HoraInicio, "HH:mm:ss").format("HH:mm") <=
                    moment(this.selectedTime, "HH:mm").format("HH:mm")
                ) {
                  this.players[index].TarifaSelected = {
                    Tarifa: tarifa,
                    Turista: tarifa.Turista,
                    Iid: tarifa.Iid,
                    Color: tarifa.Color,
                    Nombre: tarifa.text,
                    TarifaId: tarifa.value,
                    Horario: horario,
                    tarifarioNombre: tarifarioData.Nombre,
                    horarioNombre: horario.data.Nombre,
                    Precio: horario.PcoVen,
                    PrecioCon: horario.PcoCon,
                    Moneda: horario.Moneda,
                  };
                  this.players[index].Precio = customPrice
                    ? Number(customPrice)
                    : Number(horario.PcoVen);
                  this.$forceUpdate();
                }
              });
            }
          });
        }

        this.$forceUpdate();
        this.forceRecomputeCounter++;
      } catch (e) {
        console.log(e);
      }
    },
    deletePlayer(index) {
      this.players.splice(index, 1);
      this.playersNumber = this.players.length;
      this.forceRecomputeCounter++;
    },
    changeAsGuest() {
      var $this = this;
      if (this.checkAsGuest == true) {
        var pNumber = 1;
        $this.players.forEach(async function (element, index) {
          if (index != 0 && element.name == "") {
            element.name = "Guest " + pNumber;
            element.email = "guest@guestmail.com";
            element.tarifario = $this.guessConfig.tarifario;
            await $this.getTarifasByTarifario(index);
            let tarifa = "";
            element.listadoTarifas.forEach((tar) => {
              if (tar.data.Subcategoria[0] == $this.guessConfig.categoria) {
                tarifa = tar;
              }
            });
            if (tarifa != "") {
              element.tarifa = tarifa.value;
              $this.getTarifasByPlayer(index);
            }
            pNumber++;
          }
        });
      } else {
        $this.players.forEach(function (element, index) {
          if (index != 0) {
            element.name = "";
            element.email = "";
          }
        });
      }
    },
    async setTarifaRodasSerie(use, index) {
      if (use) {
        this.players[index].TarifaSelected = {
          Accesos: ["Global"],
          Nombre: "Ronda Prepagada",
          TarifaId: "rondaCupon",
          Precio: 0,
          horarioNombre: "",
          Moneda: "USD",
        };
        this.players[index].tarifa = "rondaCupon";
        this.players[index].useCupon = false;
        this.players[index].Precio = 0;
      } else {
        this.players[index].Tarifas = "";
        this.players[index].TarifaSelected = "";
        this.players[index].Precio = "";
      }

      //tarifas_array.push(tarifa_global);
    },
    setTransData(data) {
      if (data.useTransportacion) {
        this.Transportacion = data.dataForm;
      } else {
        this.Transportacion = null;
      }
    },
    async getUserGroups() {
      const data =
        await this.$store.getters.getFirebaseApp.database.queryBuilder(
          "PDV/GruposCliente"
        );
      let arrayGrupos = Object.entries(data.val());

      let grupos = [];
      arrayGrupos.forEach(function (element) {
        grupos.push({ value: element[0], text: element[1]["Nombre"] });
      });
      this.gruposCliente = grupos;
    },
    addCartRider() {
      if (this.cartRiderName !== "") {
        this.cartRiders.push({
          Nombre: this.cartRiderName,
          Pco: {
            C: this.Addons.cartRider.Precio,
            M: this.Addons.cartRider.Moneda,
          },
          UID: UID.getUID(),
        });
        this.cartRiderName = "";
        /*if(this.transportation){
               // this.getTransportationData();
            }*/
      } else {
        this.$swal({
          icon: "error",
          title: "Cart Rider Name is required",
          text: "",
        });
      }
    },
    deleteCartRider(index) {
      this.cartRiders.splice(index, 1);
      //this.getTransportationData();
    },
    toggleModal() {
      this.modalOpen = !this.modalOpen;
    },
    async onChangeStatus() {
      this.$swal({
        title: "Cancelar la reservación",
        text: "El estatus de la reservación cambiara a cancelado, los jugadores se cancelaran. Este cambio se aplicara permanentemente. ",
        icon: "warning",
        allowOutsideClick: false,
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Cancelar Reserva",
        showLoaderOnConfirm: true,
        preConfirm: async () => {
          //var addReserva = this.$store.getters.getFirebaseApp.fba.call('RVA-Reservas-crearReserva');
          return await this.$store.getters.getFirebaseApp.fba
            .call("RVA-Reservas-cambiarStatus", {
              Estatus: "Cancelled",
              reservaId: this.reservaEdit.id,
              Departamento: this.reservaEdit.Departamento,
            })
            .then(function (result) {
              return result;
            })
            .catch((error) => {
              this.$swal.showValidationMessage(`Request failed: ${error}`);
            });
        },
      }).then((result) => {
        if (result.value.data.ok) {
          this.$swal("Guardado", "Cambios guardados con éxito", "success");

          this.$emit("closeModal");
        } else {
          this.$swal(
            "Error modificando el status de la reserva",
            result.value.data.error,
            "error"
          );
        }
      });
    },
    onChangeMayorista() {
      let mayorista = this.$pgsHelper.getById(
        this.mayoristas.mayoristas,
        "id",
        this.Mayorista.Id
      );
      if (mayorista) {
        this.Mayorista.Nm = mayorista.Nombre;
      }
    },
    onChangeConcierge() {
      if (this.Concierge) {
        let mayorista = this.$pgsHelper.getById(
          this.concierges,
          "id",
          this.Concierge.Id
        );

        if (mayorista) {
          this.Concierge.Nm = mayorista.nom;
        }
      }
    },
    cancelarJugador(player, index, estatus) {
      let datos = {
        idReserva: this.reservaEdit.id,
        idxPlayer: index,
        Estatus: estatus,
        Departamento: "Golf",
      };
      let title = estatus
        ? "¿Deseas marcar a este jugador como cancelado ?"
        : "¿Deseas marcar a este jugador como activo ?";
      let text = estatus
        ? " El jugador no estara disponible al cancelar su lugar en la reserva"
        : " El jugador  estara disponible al activar su lugar en la reserva";
      this.$swal({
        title: title,
        text: text,
        icon: "warning",
        allowOutsideClick: false,
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Cambiar estatus del jugador",
        showLoaderOnConfirm: true,
        preConfirm: async () => {
          return await this.$store.getters.getFirebaseApp.fba
            .call("RVA-Reservas-cancelarJugador", datos)
            .then(function (result) {
              return result;
            })
            .catch((error) => {
              this.$swal.showValidationMessage(`Request failed: ${error}`);
            });
        },
      }).then((result) => {
        if (result.value) {
          if (result.value.data.ok) {
            this.players[index].estatus = estatus ? "C" : "R";
            this.$forceUpdate();
            this.$swal({
              title: "Guardado",
              text: "El jugador editado correctamente",
              icon: "success",
            });
          } else {
            this.$swal(
              "Error editando jugador",
              result.value.data.error,
              "error"
            );
          }
        }
      });
    },
    changeTrans(value) {
      //this.transportation = value;
      if (value == true) {
        this.transModal = true;
      } else {
        /*if(this.selectedPriceIndex === ""){
                this.$swal(
                    'Selecciona un horario',
                    'Selecciona un horario de juego antes de solicitar transportacion ',
                    'error'
                )

                document.getElementsByName('trans').forEach((element =>{
                    element.checked = false;
                }))
        }else if(this.transportation && this.selectedPriceIndex !== ""){
            if(this.isHotel){
                this.getTransportationData();
            }
            
        }*/
        this.Session = "";
        this.ApiToken = "";
        this.TotalTrans = 0;
        this.RowId = "";
        this.RsvaId = "";
        this.DuracionViaje = "";
        this.HtlPickup = "";
        this.PCGCPickup = "";
        //this.Confirm ="";
        this.transportation = value;
        this.tranindx++;
        this.$swal(
          "No se transportara a los jugadores",
          "La transportacion al campo de golf  no sera incluida en esta reserva ",
          "error"
        );
      }
    },
    async parseData(cat, index) {
      this.modalidad = cat.ExtraParams.TarifaData.Mod;
      this.$forceUpdate();

      if (cat.Tip == "RVA-Addon") {
        this.players[index].golfClub = true;
        this.players[index].side = cat.ExtraParams.GCExtraData.Side;
        this.players[index].genero = cat.ExtraParams.GCExtraData.Gender;
        this.players[index].shaft = cat.ExtraParams.GCExtraData.Shaft;
      } else if (cat.Tip == "Reserva") {
        if (cat.Tip == "Serie") {
          this.setPlayerData(this.players[index], index);
          this.players[index].useRondaCupon = true;
          this.setTarifaRodasSerie(this.players[index].useRondaCupon, index);
        } else if (cat.Tip == "Reserva") {
          let TarifaId = cat.Id;
          let tarifa = await TarifasClass.getTarifaById(TarifaId);

          this.players[index].tarifario = tarifa.Tarifario;
          this.players[index].tarifa = TarifaId;
          this.players[index].Precio = cat?.Pco || 0;
          await this.getTarifasByTarifario(index);
          //playerData.tarifario=cat.Catalogo[0].ExtraParams
          await this.getTarifasByPlayer(index, this.players[index].Precio);
          this.players[index].accountSnapshot = cat;
          this.players[index].nCarrito = cat.ExtraParams?.JuegoData?.Can;
          this.players[index].useCupon = cat.ExtraParams.TarifaData.EC;
          //si es invitado
          this.players[index].IdMiembro =
            cat.ExtraTip == "MBS-Beneficio"
              ? cat.Catalogo[0].ExtraParams.BeneficioData.Miembro
              : null;
          let invitado =
            cat.ExtraTip == "MBS-Beneficio"
              ? cat.ExtraParams.BeneficioData.Invitado
              : false;
          this.players[index].esInvitado = invitado;
          if (cat.ExtraTip == "MBS-Beneficio") {
            this.changeMiembroInvitado(this.players[index], index);
          }
        }
      }
      this.players[index].loading = false;
    },
    buildReservationData() {
      var valid = true;
      if (this.$refs.playersForm.validate()) {
        console.log("valido");
      }
      let aux = 0;
      let playersError = "";
      /*this.players.forEach((element, index) => {
        playersError = playersError + "Jugador " + (index + 1) + " ";
        if (element.name == "" || element.tarifa == "") {
          aux++;
        }
      });*/

      if (aux > 0) {
        valid = false;
        this.errors.players = true;
      } else {
        this.errors.players = false;
      }

      if (!valid) {
        this.$swal(
          "Complete la información de los jugadores correctamente",
          "Verifique el nombre y la tarifa de: " + playersError,
          "error"
        );
        return false;
      }

      let resData = ReservaClass.buildRVAData({
        Tipo: "Golf",
        Cliente: this.players[0],
        Players: this.players,
        Estatus: "Confirmed",
        Privado: false,
        Familia: this.ConfigRva?.Contabilidad?.Familia,
        FechaInicial:
          this.input_date.format("YYYY-MM-DD") +
          "_" +
          moment(this.selectedTime, "HH:mm").format("HH:mm:ss"),
        FechaFinal:
          this.input_date.format("YYYY-MM-DD") +
          "_" +
          moment(this.selectedTimeEnd, "HH:mm").format("HH:mm:ss"),
        Total: this.grandTotal,
        Prepagado: this.typePaid === 1 ? true : false,
        Notas: this.nota,
        Departamento: this.rvaDepto,
        Tags: ["GOLF"],
        Bahia: this.Bahia,
        Creador: this.isWeb ? "Web" : "ProShop",
        Invitados: Number(this.Invitados),
        Modalidad: this.$pgsHelper.getById(
          this.tiposJuego,
          "id",
          this.modalidad
        ),
        CartRiders: this.cartRiders,
        Addons: this.Addons,
        Mayorista: this.Mayorista.Id ? this.Mayorista : null,
        Concierge: this.Concierge.Id ? this.Concierge : null,
        Transportacion: this.Transportacion,
      });

      let doAction = "EDIT";
      resData.Id = this.Id;
      //delete resData.Transportacion;

      this.$emit("successData", resData, doAction);
    },
    async getConfig() {
      const conf =
        await this.$store.getters.getFirebaseApp.database.queryBuilder(
          "RVA/Configuracion/" + localStorage.getItem("selectedDepartment") + ""
        );
      let resultConf = conf.val();
      this.ConfigRva = resultConf;
      this.guessConfig = resultConf?.GUEST;
    },
    initTransportacion() {
      if (this.Transportacion) {
        this.$refs.transportacion.intiForm(this.Transportacion);
      }
    },
  },
  computed: {
    ...mapGetters(["getPDVMonedasLista"]),
    comp_bahias() {
      let bahias = [];
      for (let index = 1; index <= this.slotsNumber; index++) {
        bahias.push({ Name: "B" + index });
      }
      return bahias;
    },
    tiposCambio() {
      let cambio = this.$store.getters.getTiposCambios;
      return cambio[0];
    },
    mayoristas() {
      let mayoristas = this.$store.getters.getMayoristas;
      let mayoristasComp = [{ id: null, Nombre: "Sin Agencia" }];
      mayoristas.forEach((element) => {
        mayoristasComp.push({
          value: element.id,
          text: element.Nombre,
          ...element,
        });
      });

      return { mayoristas: mayoristasComp, mayoristasSearch: mayoristasComp };
    },
    concierges() {
      let concierges = this.Concierges;
      let conciergeComp = [{ id: null, nom: "Sin Concierge" }];
      concierges.forEach((element) => {
        if (!element.dlat) {
          if (this.Mayorista.Id) {
            if (element.htl.id == this.Mayorista.Id) {
              conciergeComp.push({
                value: element.id,
                text: element.nm,
                ...element,
              });
            }
          } else {
            conciergeComp.push({
              value: element.id,
              text: element.nm,
              ...element,
            });
          }
        }
      });

      return conciergeComp;
    },
    Addons() {
      /*
        Obtiene las temporadas existentes en la db
        */
      let AddOn = {};
      let addons = this.$store.getters.getRVACatalogo;
      AddOn.cartRider = addons.GOLFRIDDER; //arrayExt;
      AddOn.golfClub = addons.GOLFCLUB; //arrayGb;
      AddOn.transport = addons.TRANSPORT;
      AddOn.roundGolf = addons.GOLFROUND;
      return AddOn;
    },
    data_clientes() {
      let clientes = [];
      let rowclientes = Cliente.getClientsList();
      rowclientes.forEach((element) => {
        if (element.Id != "PUBLICOGENERAL") {
          clientes.push(element);
        }
      });

      return clientes;
    },

    comp_clients() {
      let clientes = [];
      this.data_clientes.forEach((cli) => {
        if (cli.ExtraData?.Membresia?.Membresia) {
          cli.esMiembro = true;
        } else {
          cli.esMiembro = false;
        }
        cli.text = cli.getNombreCompleto();
        clientes.push(cli);
      });
      return this.$_.orderBy(clientes, "text", "asc");
      //return clientes;
    },
    grandTotal() {
      /* calcula el total de la reserva, segun el tipo de pago y los items seleccionados */
      let total = 0;
      let totalPesos = 0;

      this.players.forEach((element) => {
        if (element.TarifaSelected && element.estatus == "R") {
          let montoTarifa = element.Precio;
          if (element.TarifaSelected.Moneda == "USD") {
            total += montoTarifa;
            totalPesos += montoTarifa * this.tiposCambio.TC.USD;
          } else {
            total += montoTarifa / this.tiposCambio.TC.USD;
            totalPesos += montoTarifa;
          }
        }
      });

      total += parseInt(this.TotalTrans);
      totalPesos += parseFloat(this.TotalTrans) * this.tiposCambio.TC.USD;

      this.players.forEach((element) => {
        if (element.golfClub && element.estatus == "R") {
          if (this.Addons.golfClub.Moneda == "USD") {
            total += this.Addons.golfClub.Precio;
            totalPesos += this.Addons.golfClub.Precio * this.tiposCambio.TC.USD;
          } else {
            total += this.Addons.golfClub.Precio / this.tiposCambio.TC.USD;
            totalPesos += this.Addons.golfClub.Precio;
          }
        }
      });
      this.cartRiders.forEach(() => {
        if (this.Addons.cartRider.Moneda == "USD") {
          total += this.Addons.cartRider.Precio;
          totalPesos += this.Addons.cartRider.Precio * this.tiposCambio.TC.USD;
        } else {
          total += this.Addons.cartRider.Precio / this.tiposCambio.TC.USD;
          totalPesos += this.Addons.cartRider.Precio;
        }
      });

      if (this.typePaid === 1) {
        total = 0;
        totalPesos = 0;
      }

      return { total: total, totalPesos: totalPesos };
    },
  },
  watch: {},
  async beforeMount() {
    //await this.getUserGroups();
    //this.init();
    /*this.input_date = this.selectedT.date
      this.selectedTime = this.selectedT.time

      this.getUserGroups();
      this.init(); */
  },
  async mounted() {
    await this.getHorarios();
    await this.getTemporadas();
    await this.init();

    //await this.getTemporadas();
    this.getConfig();
    this.getCajeros();
    if (this.editMode) {
      this.Id = this.editData.id;
      (this.Folio = this.editData.Folio),
        (this.Mayorista = this.editData.Mayorista
          ? this.editData.Mayorista
          : { Id: null, Nm: "" });
      moment.locale("es");
      this.Concierge = this.editData.Concierge
        ? this.editData.Concierge
        : { Id: null, Nm: "" };
      let date = moment(this.editData.RF.FI, "YYYY-MM-DD_HH:mm:ss");
      let dateF = moment(this.editData.RF.FT, "YYYY-MM-DD_HH:mm:ss");
      this.input_date = date;
      this.Transportacion = this.editData.Transportacion
        ? this.editData.Transportacion
        : null;
      this.initTransportacion();
      this.nota = this.editData.Notas;
      this.date = date.format("YYYY-MM-DD");
      this.selectedTime = date.format("HH:mm");
      this.selectedTimeEnd = dateF.format("HH:mm");
      this.timeEdit = date.format("YYYY-MM-DDTHH:mm");
      this.timeEndEdit = dateF.format("YYYY-MM-DDTHH:mm");
      this.reservaEdit = this.editData;
      this.Bahia = this.editData.Bahia;
      this.Invitados = this.editData.Invitados;

      this.players = [];
      if (this.reservaEdit.Prepagado) {
        this.typePaid = 1;
      } else {
        this.typePaid = 2;
      }
      if (this.reservaEdit.Acompañantes) {
        this.cartRiders = this.reservaEdit.Acompañantes;
      }
      this.reservaEdit.Cuentas.forEach((cuenta, index) => {
        if (cuenta.indexCuenta != "Extra") {
          let playerData = {
            loading: true,
            listadoTarifas: [],
            tarifario: "",
            totalCupones: 0,
            useRondaCupon: false,
            dataClient: cuenta.IdCliente
              ? this.$pgsHelper.getById(
                  this.comp_clients,
                  "Id",
                  cuenta.IdCliente
                )
              : cuenta.Nombre,
            cuponSelected: "",
            combo_cupon: [],
            formMayorista: "",
            useCupon: false,
            esInvitado: false,
            IdMiembro: "",
            invitation: { valid: false },
            name: cuenta.Nombre,
            email: cuenta.Correo,
            estatus: cuenta.Estatus,
            accountSnapshot: cuenta,
            phone: "",
            golfClub: false,
            side: "right",
            genero: "Man",
            shaft: "regular",
            tarifa: "",
            isClient: cuenta.IdCliente ? true : false,
            TarifaSelected: "",
            nCarrito: "",
            Precio: 0,
            IdCliente: cuenta.IdCliente ? cuenta.IdCliente : null,
          };

          this.players.push(playerData);
          this.setPlayerData(this.players[index], index);
          let taskCatalogos = cuenta.Catalogo.map(async (cat) => {
            if (cat.Tip == "Cupon") {
              cat.Catalogo.forEach(async (catalogo) => {
                await this.getSubcategoria();
                await this.parseData(catalogo, index);
              });
            } else {
              await this.getSubcategoria();
              await this.parseData(cat, index);
            }
          });
          Promise.all(taskCatalogos).then(() => {});
          //this.modalidad = '-Ly-mXjov1u8rY9G4FSi'
          this.$forceUpdate(); //
        } else if (cuenta.indexCuenta == "Extra") {
          cuenta.Catalogo.forEach((catalogo) => {
            if (catalogo.ExtraParams.ERExtraData) {
              catalogo.ExtraParams.ERExtraData.forEach((exr) => {
                this.cartRiders.push({ name: exr.N });
              });
            }
          });
        }
      });
      this.playersNumber = this.players.length;

      this.doAction = "EDIT";
    }
  },
  async created() {
    //await this.getUserGroups();
    this.allowPlayers = Number(this.maxPlayers); //-
    //Number(this.selectedT.personas ? this.selectedT.personas : 0);
  },
};
</script>
<style>
.btnCard {
  border: 2px solid !important;
  border-color: #1976d2 !important;
}
.accesoDenegado {
  background: #ff00005c;
}
.bottomPanel {
  width: 100%;
}
@media screen and (max-width: 600px) {
  .bottomPanel {
    width: 100%;
  }
}
</style>
